import React from 'react';

function Rules() {
  return (
    <div className="lorem-ipsum" style={{marginTop: "16px"}}>
      <h6 className='justify-content-center' style={{fontWeight: "402"}}>
      In diesem Kartenspiel spielen Sie gemeinsam als Team. Ihre Aufgabe ist es einen smarten Grill zu entwickeln. Dazu müssen Sie  Methodenkarten miteinander Kombinieren. Diese App unterstützt Sie dabei die Gültigkeit ihrer Kombinationen zu prüfen und mehr Informationen über die Modelle zu erhalten. Wechseln Sie dafür zwischen den Reitern "Kombinieren" und "Info".
      </h6>
      <hr className="light-hr" />
    </div>
  );
}

export default Rules;
